
export default function ResultsSection() {
  const stats = [
    {
      icon: 'ri-building-line',
      number: '+100',
      label: 'projetos executados em todo os estado de São Paulo'
    },
    {
      icon: 'ri-file-check-line',
      number: '+50',
      label: 'regularizações e 10+ eventos liberados em um único mês'
    },
    {
      icon: 'ri-team-line',
      number: 'Parcerias',
      label: 'com lojas premium de mobiliário e acabamentos'
    },
    {
      icon: 'ri-star-line',
      number: 'Índice',
      label: 'de satisfação e recompra acima da média do setor'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3F3F3F] mb-6">
            Resultados que constroem reputação.
          </h2>
          <p className="max-w-4xl mx-auto text-base text-[#3F3F3F] leading-relaxed">
            A P&P consolidou seu nome atendendo clientes exigentes e marcas reconhecidas. 
            De residências de alto padrão a espaços corporativos e comerciais sofisticados, 
            cada entrega reforça o que nos diferencia: a confiança que vem da entrega impecável.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-6 bg-[#F2F2F2] rounded-lg">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#5C1A24] rounded-full flex items-center justify-center">
                <i className={`${stat.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-2xl font-bold text-[#5C1A24] mb-2">
                {stat.number}
              </div>
              <p className="text-sm text-[#3F3F3F] font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
